"use client";

import { installDomReconciliationGuard } from "@/lib/domReconciliationGuard";

installDomReconciliationGuard();
